import React, { useState, useEffect } from "react";
import axios from "axios";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";

const BOReqViewSingle = () => {
  useAuthRedirect();
    const {prNo, sNo} = useParams();
  const branch = localStorage.getItem("branch");
  const [indentView, setIndentView] = useState({});
  const [data, setData] = useState([]);
  const [showLifeDetail, setShowLifeDetail] = useState(false);
  const canView  = hasPermission("Branch office Requisition", "view");


  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/bo_detailsHeader?prNo=${prNo}&branch=${branch}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                date: items[0].prHeader_date || "N/A",
                dept: items[0].departmentMaster_name || "N/A",
                branchCode: items[0].branchCode || "N/A",
                prHeader_hod: items[0].prHeader_hod || "N/A",
                prHeader_headMaterial: items[0].prHeader_headMaterial || "N/A",
                prHeader_remarks: items[0].prHeader_remarks || "N/A",
            };

            setIndentView(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [prNo, branch]); 

 const [loading, setLoading] = useState(true); // ✅ loading state

useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true); // start loading
      const response = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/bo_bottomDetails?prNo=${prNo}&branch=${branch}&sCode=${sNo}`
      );
      setData(response.data.bottomDetails || []);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
      setData([]);
    } finally {
      setLoading(false); // stop loading
    }
  };

  fetchData();
}, [prNo, branch, sNo]);
if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
            <div className="back-div">
                        <h2 className="add-txt">Branch Office Purchase Requisition - view</h2>
                        <Link to='/inventory/mis_prview'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                        </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
          <div className="form-row">
              <div className="form-group">
                <label>Pr No :</label>
                <input type="text" name="indentNo" value={prNo} readOnly/>
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input
  type="text"
  name="endhrs"
  value={indentView.date ? new Date(indentView.date).toISOString().split("T")[0] : ""}
 readOnly
/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Branch :</label>
                <input type="text" name="indentNo" value={indentView.branchCode} readOnly/>
              </div>
              <div className="form-group">
                <label>Department :</label>
                <input type="text" value={indentView.dept} name="user"  readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>H.O.D :</label>
                <input type="text" value={indentView.prHeader_hod} name="remarks" readOnly />
              </div>
              <div className="form-group">
                <label>Head Meterial</label>
                <input type="text" value={indentView.prHeader_headMaterial} name="remarks" readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" value={indentView.prHeader_remarks} name="remarks" readOnly />
              </div>
              <div className="form-group">
                <label></label>
                <input type="hidden"  />
              </div>
            </div>


            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Supplier</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Qty</th>
                    <th>Due Date</th>
                     {showLifeDetail && (
      <th style={{ textAlign: "center" }}>
        Life Detail
      </th>
    )}
     <th>
          <button
            type="button"
            onClick={() => setShowLifeDetail(!showLifeDetail)}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
            }}
          >
            {showLifeDetail ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </th>
                  </tr>
                </thead>
                <tbody>
  {loading ? (
    <tr>
      <td colSpan="9" style={{ textAlign: "center", fontWeight: "bold" }}>
        Loading data, please wait...
      </td>
    </tr>
  ) : data.length > 0 ? (
    data.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>
          {item.supplierMaster_code} - {item.supplierMaster_name}
        </td>
        <td>{item.prDetail_itemcode}</td>
        <td>{item.itemmaster_name}</td>
        <td>{item.itemMaster_purchaseUom}</td>
        <td>{item.prDetail_quantity}</td>
        <td>
          {item.prDetail_duedate
            ? new Date(item.prDetail_duedate).toLocaleDateString("en-GB")
            : ""}
        </td>
        {showLifeDetail && <td>{item.prDetail_lifeTime}</td>}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="9" style={{ textAlign: "center" }}>
        No items
      </td>
    </tr>
  )}
</tbody>
              </table>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
};

export default BOReqViewSingle;
